import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography, Dialog, DialogTitle, DialogContent, Card, CardContent, IconButton } from '@mui/material';
import { useGetGlobalItemsQuery } from '../store/docApi';
import { Search, Close } from '@mui/icons-material';

export default function ChromaBrowser({ onSelect, onClose }) {
  const { data: yarns } = useGetGlobalItemsQuery({ label: 'yarn' });
  const [availableChromas, setAvailableChromas] = useState([]);
  const [filteredChromas, setFilteredChromas] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedYarn, setSelectedYarn] = useState(null);

  useEffect(() => {
    if (yarns && yarns.length > 0) {
      setSelectedYarn(yarns[0]);
    }
  }, [yarns]);

  useEffect(() => {
    if (selectedYarn) {
      setAvailableChromas(selectedYarn.chromas || []);
      setFilteredChromas(selectedYarn.chromas || []);
    }
  }, [selectedYarn]);

  useEffect(() => {
    if (searchKeyword) {
      const filtered = availableChromas.filter(
        (chroma) =>
          chroma.name.toLowerCase().includes(searchKeyword.toLowerCase()) || chroma.code.toLowerCase().includes(searchKeyword.toLowerCase())
      );
      setFilteredChromas(filtered);
    } else {
      setFilteredChromas(availableChromas);
    }
  }, [searchKeyword, availableChromas]);

  return (
    <Dialog open={true} onClose={onClose} fullWidth>
      <DialogTitle>
        Browse Yarn Colors
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'grid', gap: 1, gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))', mb: 2 }}>
          {yarns &&
            yarns.map((yarn, index) => (
              <Card
                key={index}
                variant="outlined"
                sx={{
                  cursor: 'pointer',
                  p: 1,
                  textAlign: 'center',
                  backgroundColor: selectedYarn === yarn ? 'primary.light' : 'background.paper',
                  '&:hover': { boxShadow: 1 }
                }}
                onClick={() => setSelectedYarn(yarn)}
              >
                <Typography variant="subtitle1">{yarn.name}</Typography>
              </Card>
            ))}
        </Box>
        <TextField
          variant="outlined"
          placeholder="Search..."
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
          fullWidth
          InputProps={{
            startAdornment: <Search sx={{ mr: 1 }} />
          }}
          sx={{ mb: 2 }}
        />
        <Box
          sx={{
            display: 'grid',
            gap: 1,
            gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
            minHeight: 200,
            maxHeight: 300,
            overflowY: 'auto',
            maxWidth: 600
          }}
        >
          {filteredChromas &&
            filteredChromas.map((chroma, index) => (
              <Card
                key={index}
                variant="outlined"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  '&:hover': { boxShadow: 1 }
                }}
                onClick={() => onSelect(chroma)}
              >
                <Box sx={{ bgcolor: chroma.color, width: 20, height: 20, mr: 1 }} />
                <CardContent sx={{ p: 1 }}>
                  <Typography variant="subtitle2">{chroma.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {chroma.code}
                  </Typography>
                </CardContent>
              </Card>
            ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
